export default __webpack_public_path__ + "static/media/locationWhite.9552d768.svg";